import { api } from '@/shared/api/client';
import type { LoginResponse } from '@/shared/auth/storage';

export interface OtpStartResponse {
  SessionId: string;
  ExpiresAt: string;
  DisplayInstruction?: string;
}
export type OtpStatus = 'PENDING' | 'VERIFIED' | 'EXPIRED' | 'FAILED';
export interface OtpStatusResponse {
  SessionStatus: OtpStatus;
}

export interface TenantInfo {
  Id: string;
  Code?: string;
  Name: string;
}
export interface CompanyInfo {
  Id: string;
  Code?: string;
  Name: string;
  BusinessType?: number;
}

export const authApi = {
  startOtp: (phone: string) => api.post<OtpStartResponse>('/api/sms-otp/start', { Phone: phone }),
  pollOtp: (sessionId: string) =>
    api.get<OtpStatusResponse>('/api/sms-otp/status/' + encodeURIComponent(sessionId)),
  phoneLogin: (phone: string, sessionId: string) =>
    api.post<LoginResponse>('/api/auth/phone-login', { Phone: phone, SessionId: sessionId }),
  passwordLogin: (phone: string, password: string) =>
    api.post<LoginResponse>('/api/auth/password-login', { Phone: phone, Password: password }),

  myTenants: () => api.get<TenantInfo[]>('/api/tenant/my'),
  companiesByTenant: (tenantId: string) =>
    api.get<CompanyInfo[]>(`/api/company/by-tenant/${tenantId}`),
};

// ---- Portal (customer) ----
export interface MyMembership {
  TenantId: string;
  CompanyId: string;
  CompanyName: string;
  WarehouseCode: string;
}
export interface MyShipment {
  Id: string;
  TrackingNo: string;
  Status: number;
  StatusLabel: string;
  DeclaredContent?: string;
  WeightKg: number;
  Charge: number;
  PaymentStatus: number;
  PaymentStatusLabel: string;
  CreatedOn?: string;
  DeliveredOn?: string;
}
export interface TrackResult {
  TrackingNo: string;
  Status: number;
  StatusLabel: string;
  CompanyName?: string;
  CreatedOn?: string;
  DeliveredOn?: string;
  TrackingEvents: { Id: string; EventType: number; EventTypeLabel: string; WarehouseName?: string; OccurredOn: string; Note?: string }[];
}

export const portalApi = {
  track: (trackingNo: string) =>
    api.get<TrackResult>(`/api/cargo/track/${encodeURIComponent(trackingNo)}`, { anonymous: true }),
  memberships: () => api.get<MyMembership[]>('/api/cargo/portal/memberships'),
  myShipments: (companyId?: string) =>
    api.get<MyShipment[]>(`/api/cargo/portal/my-shipments${companyId ? `?companyId=${companyId}` : ''}`),
};
